import apiClient from "./api-client";
import { handleApiError } from "./error-handler";
import {
  ProposalConversation,
  CreateProposalConversationRequest
} from "../models/ProposalConversation";

/**
 * Get all conversations for a proposal (visible to current user)
 */
export const getProposalConversations = async (
  proposalId: number
): Promise<ProposalConversation[]> => {
  try {
    const response = await apiClient.get(
      `/proposals/${proposalId}/conversations`
    );
    return response.data;
  } catch (error: any) {
    throw handleApiError(error, 'Error fetching proposal conversations');
  }
};

/**
 * Create a new conversation message
 */
export const createProposalConversation = async (
  proposalId: number,
  request: CreateProposalConversationRequest
): Promise<ProposalConversation> => {
  try {
    const response = await apiClient.post(
      `/proposals/${proposalId}/conversations`,
      request
    );
    return response.data;
  } catch (error: any) {
    throw handleApiError(error, 'Error creating conversation message');
  }
};
